<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
<div mat-dialog-content>
    <div class="card text-center" >
        <div class="card-header bg-primary text-left text-white font-weight-bold">
            SPRA Request List
        </div>
        <div class="card-body mat-card">
            <div class="row">

                <div class="col-sm-12">
                    <!-- (keyup)="doFilter($event)"  -->
                    <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control"
                            placeholder="Filter" (keyup)="doFilter($event)">
                    </div>
                </div>

                <div class="col-sm-12">
                    <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc" multiTemplateDataRows *ngIf="dataSource.data.length>0">
                        <!-- Position Column -->
                        <ng-container matColumnDef="requestNo">
                            <mat-header-cell  mat-sort-header *matHeaderCellDef> Request No. </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="btn-link text-primary " (click)="onRequestClick(element)"> {{element.requestNo}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="requestDate">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Request Date </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.requestDate}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="branch">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Branch </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.branch}} </mat-cell>
                        </ng-container>


                        <ng-container matColumnDef="partyName">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Party Name </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.partyName}}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="saleType">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Sale Type</mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.saleType}}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="enteredBy">
                            <mat-header-cell mat-sort-header *matHeaderCellDef> Entered By</mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                {{element.enteredBy}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="isRental">
                            <mat-header-cell mat-sort-header *matHeaderCellDef>Rental </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.isRental==true?'Yes':'No'}} </mat-cell>
                            
                          </ng-container>

                        <mat-header-row *matHeaderRowDef="SpraListHeader"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: SpraListHeader;"></mat-row>

                    </mat-table>
                </div>
                <div *ngIf="dataSource.data.length == 0" class="col-sm-12">No Data Exists</div>

                <div class="col-sm-12">
                    <div class="col-sm-6 float-right text-right">
                        <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>


